import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { AppShell } from '@/components/shell/app-shell';
import { DeactivatedOverlay } from '@/components/shell/deactivated-overlay';
import { ApiRequestError } from '@/lib/api-client';
import { meQuery } from '@/lib/queries';

/** Everything behind sign-in. Unauthenticated visitors go to /login and come back afterwards. */
export const Route = createFileRoute('/_app')({
  beforeLoad: async ({ context, location }) => {
    try {
      await context.queryClient.ensureQueryData(meQuery);
    } catch (error) {
      if (error instanceof ApiRequestError && (error.status === 401 || error.status === 403)) {
        throw redirect({ to: '/login', search: { redirect: location.href } });
      }
      throw error;
    }
  },
  component: () => (
    <>
      <AppShell>
        <Outlet />
      </AppShell>
      {/* Over everything (sheets, dialogs, toasts) while an admin has deactivated the account. */}
      <DeactivatedOverlay />
    </>
  ),
});
